exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\r\n#root, .app, html, body, .PageBox{\r\n    margin: 0px;\r\n    padding: 0px;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./src/App/components/Layout/styles.css
// module id = 1426
// module chunks = 0